/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */

import { Component, Input } from '@angular/core';

import { cva, VariantProps } from 'class-variance-authority';
import { IconComponent } from '../icon/icon.component';

const bescheidStatusVariants = cva('flex items-center text-text ', {
  variants: {
    size: {
      'medium-small': 'gap-1 font-normal',
      medium: 'gap-2 font-medium',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});
type BescheidStatusVariants = VariantProps<typeof bescheidStatusVariants>;

@Component({
  selector: 'ods-bescheid-status-text',
  imports: [IconComponent],
  template: `@if (bewilligt) {
      <ods-icon name="stamp" [config]="{ fill: 'traffic-light-green', size: size }" title="Bewilligt" aria-hidden="true" />
      <p><span [class.sr-only]="!withLabel">Bewilligt am:&nbsp;</span>{{ dateText }}</p>
    } @else {
      <ods-icon name="close" [config]="{ fill: 'traffic-light-red', size: size }" title="Abgelehnt" aria-hidden="true" />
      <p><span [class.sr-only]="!withLabel">Abgelehnt am:&nbsp;</span>{{ dateText }}</p>
    }
    @if (hasBescheidDraft) {
      <p class="text-error flex items-center" data-test-class="bescheid-status-draft">(Entwurf)</p>
    }`,
  host: { '[class]': 'hostClass' },
})
export class BescheidStatusTextComponent {
  @Input({ required: true }) dateText: string = '';
  @Input() bewilligt: boolean = false;
  @Input() hasBescheidDraft: boolean = false;
  @Input() withLabel: boolean = true;
  @Input() size: BescheidStatusVariants['size'] = 'medium';

  get hostClass(): string {
    return bescheidStatusVariants({ size: this.size });
  }
}
